<div class="modal-content">
  <div class="modal-header text-center">
    <h4 class="modal-title">Translations updater</h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div *ngIf="pulling" class="modal-body">
    <div class="spinner-container">
      <hs-spinner [show]="true" text="Pulling translations..."></hs-spinner>
    </div>
  </div>
  <div *ngIf="!pulling && error" class="modal-body p-5">
    There was an error pulling translations from Traduora.
  </div>
  <div *ngIf="!pulling && !error" class="modal-body p-5">
    Translations pulled successfully! Reload the page to see changes.
  </div>
  <div class="modal-footer">
    <button *ngIf="!pulling && !error" type="button" class="btn btn-black" aria-label="Reload page"
      (click)="reloadPage()">Reload page</button>
    <button type="button" class="btn btn-pink" aria-label="Close"
      (click)="bsModal.hide()" lang>actions.close</button>
  </div>

</div>